import * as St from './DrawingAreaText.styles';

import { palette } from '~/theme';

type DrawingAreaTextProps = {
  strongText: string;
  normalText: string;
  IconComponent: React.FC<React.SVGProps<SVGSVGElement>>;
};

const DrawingAreaText = ({
  strongText,
  normalText,
  IconComponent,
}: DrawingAreaTextProps) => (
  <St.Container>
    <St.DrawIcon
      className="draw-icon"
      component={() => (
        <IconComponent
          fill={palette.blueCharcoal}
          stroke={palette.blueCharcoal}
        />
      )}
    />
    <strong>{strongText}</strong>
    <span>- {normalText}</span>
  </St.Container>
);

export default DrawingAreaText;
